/**
 * Hook pour utiliser les notifications toast
 * Encapsule sonner avec une API cohérente
 */

import { toast as sonnerToast } from 'sonner';

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success' | 'warning' | 'info';
  duration?: number;
}

export function useToast() {
  const toast = (options: ToastOptions) => {
    const { title, description, variant = 'default', duration } = options;

    // Construire le message
    const message =
      title && description
        ? `${title}: ${description}`
        : title || description || '';

    // Mapper les variants vers les méthodes sonner
    switch (variant) {
      case 'destructive':
        return sonnerToast.error(message, { duration });
      case 'success':
        return sonnerToast.success(message, { duration });
      case 'warning':
        return sonnerToast.warning(message, { duration });
      case 'info':
        return sonnerToast.info(message, { duration });
      default:
        return sonnerToast(message, { duration });
    }
  };

  return {
    toast,
    success: (message: string, options?: { duration?: number }) =>
      sonnerToast.success(message, options),
    error: (message: string, options?: { duration?: number }) =>
      sonnerToast.error(message, options),
    warning: (message: string, options?: { duration?: number }) =>
      sonnerToast.warning(message, options),
    info: (message: string, options?: { duration?: number }) =>
      sonnerToast.info(message, options),
  };
}
